import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useForm} from 'react-hook-form';
import {useMediaQuery} from 'react-responsive';

import {CustomSelect} from '../../components/CustomSelect';
import {Spinner} from '../../components/Spinner';
import {Pagination} from '../../components/Pagination';

import {fetchStudentsGroups} from '../../store/selectsData';
import {getNotificationsTeacher, sendNotification} from '../../store/notificationSlice';
import {tableHeaderTeacherNotifications} from '../../assets/utils/arrays';
import {formatDateString} from '../../assets/utils/functions';

import './style.css';

export const TeacherProfile = () => {
  const {register, handleSubmit, reset} = useForm();

  const [selectedGroup, setSelectedGroup] = useState(null);
  const [sortedNotifications, setSortedNotifications] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const {
    teacherNotificationsStatus,
    teacherNotifications,
    teacherNotificationsError,
    loadingNotification,
    notificationStatus
  } = useSelector((state) => state.notification);

  const groupsData = useSelector((state) => state.selectsData.studentsGroups);
  const userToken = useSelector((state) => state.auth.userToken);
  const dispatch = useDispatch();

  const isMobile = useMediaQuery({ maxWidth: 520 });
  const numberOfRecords = isMobile ? 5 : 10;

  useEffect(() => {
    dispatch(fetchStudentsGroups());
    dispatch(getNotificationsTeacher(userToken));
  }, []);

  useEffect(() => {
    const sortedNotifications = sortNotificationsByCreated(teacherNotifications);
    setSortedNotifications(sortedNotifications);
  }, [teacherNotifications])

  useEffect(() => {
    if (notificationStatus === 'resolved') {
      dispatch(getNotificationsTeacher(userToken));
    }
  }, [notificationStatus, dispatch, userToken]);

  const handleGroupChange = (selectedOption) => {
    setSelectedGroup(selectedOption);
  };

  const onSubmit = (data) => {
    const notificationData = {
      ...data,
      groupName: selectedGroup.value,
      token: userToken,
    };

    dispatch(sendNotification(notificationData));
    dispatch(getNotificationsTeacher(userToken));
    reset();
  };

  const sortGroupsName = (groupsData) => {
    if (!groupsData || groupsData.length === 0) {
      return [];
    }

    return groupsData.map((group) => ({
      value: group.name,
      label: group.name,
    })).sort((a, b) => a.label.localeCompare(b.label));
  };

  const sortNotificationsByCreated = (notifications) => {
    return notifications.slice().sort((a, b) => {
      const dateA = new Date(a.created);
      const dateB = new Date(b.created);

      return dateB - dateA;
    });
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const lastRecordIndex = currentPage * numberOfRecords;
  const firstRecordIndex = lastRecordIndex - numberOfRecords;
  const currentRecords = sortedNotifications.slice(firstRecordIndex, lastRecordIndex);

  return (
    <>
      <h3 className="teacher-profile-title">Отправить уведомление</h3>
      <div className="profile-fields">
        <CustomSelect
          id="groupSelect"
          className="group-select"
          options={sortGroupsName(groupsData)}
          value={selectedGroup}
          onChange={handleGroupChange}
          placeholder="Выберите группу"
        />
        <form onSubmit={handleSubmit(onSubmit)} className="notifications-form">
          <input
            className="notification-input"
            placeholder="Тема уведомления"
            {...register("topic", {required: true})}
          />
          <textarea
            className="notification-textarea"
            placeholder="Текст уведомления"
            {...register("msg", {required: true})}
          />
          <button className="notification-btn" type="submit" disabled={loadingNotification}>
            {loadingNotification ? <Spinner type="circle"/> : 'Отправить'}
          </button>
        </form>
      </div>
      {teacherNotificationsStatus !== 'loading' && !teacherNotificationsError && (
          <>
          <div className="schedule-table-block">
            <table className="schedule-table">
              <thead className="table-header">
              <tr className="table-header_row">
                {tableHeaderTeacherNotifications.map((name, index) => (
                  <th className="table-header_item" key={index}>
                    {name}
                  </th>
                ))}
              </tr>
              </thead>
              <tbody>
              {currentRecords.map((item, index) => (
                <tr key={index} className="table-body_row_item">
                  <td className="table-body_row_item">{formatDateString(item.created)}</td>
                  <td className="table-body_row_item">{item.groupName}</td>
                  <td className="table-body_row_item lesson_number">{item.topic}</td>
                  <td className="table-body_row_item">{item.msg}</td>
                </tr>
              ))}
              </tbody>
            </table>
          </div>
            <div className="mobile-notifications">
              {currentRecords.map((item, index) => (
                <div key={index} className="cart-item">
                  <h3 className="cart-item-header">{item.groupName}</h3>
                  <div className="cart-item-row"><span className="cart-span">Дата:</span>{formatDateString(item.created)}</div>
                  <div className="cart-item-row"><span className="cart-span">Тема:</span>{item.topic}</div>
                  <div className="cart-item-row"><span className="cart-span">Сообщение:</span>{item.msg}</div>
                </div>
              ))}
            </div>
            <Pagination
              currentPage={currentPage}
              numberOfRecords={numberOfRecords}
              totalRecords={sortedNotifications.length}
              onPageChange={handlePageChange}
            />
          </>

      )}
    </>
  );
};
